module.exports = __webpack_public_path__ + "static/media/slack-icon.246e4415.svg";